export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART';
export const CLEAR_CART = 'CLEAR_CART';
export const UPDATE_TOTAL_AMOUNT = 'UPDATE_TOTAL_AMOUNT';

// Action to add a product to the cart
export const addToCart = (product) => {
  return {
    type: ADD_TO_CART,
    payload: product,
  };
};

// Action to remove a product from the cart
export const removeFromCart = (productId) => {
  return {
    type: REMOVE_FROM_CART,
    payload: productId,
  };
};

// Action to clear the cart
export const clearCart = () => {
  return {
    type: CLEAR_CART,
  };
};

export const updateTotalAmount = (totalAmount) => {
  return {
    type: UPDATE_TOTAL_AMOUNT,
    payload: totalAmount,
  };
};